import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import ToolTipKeys from 'constants/ToolTipKeys';
import { TooltipMobile } from 'common/ui/tooltip/components';
import List from "@material-ui/core/List";
import clsx from "clsx";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import PlayCircleOutline from "@material-ui/icons/PlayCircleOutline";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import ListItem from "@material-ui/core/ListItem";
import LoveIcon from "@material-ui/icons/Favorite";
import LoveBorderIcon from "@material-ui/icons/FavoriteBorder";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles((theme) => ({
    list: {
        height: 'auto',
        textOverflow: 'ellipsis',
        overflow: 'scroll',
        whiteSpace: 'nowrap',
        padding: 0,
        borderTop: '1px #eee solid',
        paddingBottom: 20,
    },
    item: {
        textDecoration: 'none',
        color: '#494949',
        textAlign: 'left',
        fontSize: 14,
        cursor: 'pointer',
        borderBottom: '1px #eee solid',
    },
    icon: {
        margin: 0,
        fill: theme.palette.iconColor,
    },
}));

const MoreAction = (props) => {
    const classes = useStyles();

    const closeToolTip = () => {
        props.onHandleClose();
    };

    const onPlayClickHandler = (event) => {
        closeToolTip();
        props.onPlayClick(event);
    };

    const onDeleteClickHandler = (event) => {
        closeToolTip();
        props.onDeleteClick(event);
    };

    const onHeartClickHandler = (event) => {
        closeToolTip();
        props.onHeartClick(event);
    };

    return(
        <TooltipMobile
            title="Actions"
            toolTipKey={props.toolTipKey}
            onHandleClose={props.onHandleClose}
        >
            <List className={classes.list}>
                <ListItem
                    className={clsx('tooltip-list-item', classes.item)}
                    onClick={onPlayClickHandler}
                >
                    {props.toolTipKey === ToolTipKeys.PodCastMoreAction ?
                        <ListItemText primary="Open" /> :
                        <ListItemText primary="Play" />
                    }
                    <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="play">
                            {props.toolTipKey === ToolTipKeys.PodCastMoreAction ?
                                <RadioButtonUncheckedIcon className={classes.icon} /> :
                                <PlayCircleOutline className={classes.icon} />
                            }
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                {props.editable && (
                    <ListItem
                        className={clsx('tooltip-list-item', classes.item)}
                        onClick={onDeleteClickHandler}
                    >
                        <ListItemText primary="Delete" />
                        <ListItemSecondaryAction>
                            <IconButton edge="end" aria-label="delete" onClick={onDeleteClickHandler}>
                                <DeleteIcon className={classes.icon} />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                )}
                {!props.hearted && (
                    <ListItem
                        className={clsx('tooltip-list-item', classes.item)}
                        onClick={onHeartClickHandler}
                    >
                        {props.isHearted ? (
                            <>
                                <ListItemText primary="Unheart" />
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="Favorite">
                                        <LoveIcon className={classes.icon} />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </>
                        ) : (
                            <>
                                <ListItemText primary="Heart" />
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="UnFavorite">
                                        <LoveBorderIcon className={classes.icon} />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </>
                        )}
                    </ListItem>
                )}
            </List>
        </TooltipMobile>
    );
};

export default MoreAction;